import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Breadcrumb,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Button,
  Spin,
  Tooltip,
  message,
} from "antd";
import { getRequest, patchRequest } from "../../axios";
import { Trans, useTranslation } from "react-i18next";
import { authUserData } from "../../utils/Helper";
import moment from "moment";
import ButtonField from "../../common/htmlComponents/ButtonField";
import ExelDownload from "../../image/exeldownload.svg";
import RefreshIcon from "../../image/refreshIcon.svg";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { t } from "i18next";
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";
import { Space, Table, Card } from "antd";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import jsPDF from "jspdf";
import { EyeOutlined, FilterOutlined, UndoOutlined } from "@ant-design/icons";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const PurchaseOrderSpendAnalysisReport = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [detailsSource, setDetailsSource] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [clickedFilterButton, setClickedFilterButton] = useState(false);
  const formRef = useRef();
  const [allSites, setAllSites] = useState(null);
  const [allMaterials, setAllMaterials] = useState(null);
  const [allVendors, setAllVendors] = useState(null);
  const [selectedSite, setSelectedSite] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState([]);


  const options = {
    chart: {
      id: "basic-bar",
    },
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    },
  };

  const series = [
    {
      name: "Series 1",
      data: [30, 40, 35, 50, 49, 60],
    },
  ];
  const [state, setState] = useState({
    page: 1,
    pagesize: 10,
  });
  useEffect(() => {
    const getReportData = async () => {
      setapiLoading(true);
      try {
        const response = await getRequest(
          `po-order/po-spend-analysis-report/?company_id=${CompanyId}`,
          state
        );
        setDataSource(response.data.results.data);
        settotalCount(response.data.count);
      } catch (error) {
        console.error("Error:", error);
        setapiLoading(false);
      } finally {
        setapiLoading(false);
      }
    };
    getReportData();
  }, [reload, state, t]);

  useEffect(() => {
    const getReportData = async () => {
      setapiLoading(true);
      try {
        const response = await getRequest(
          `delivery-address/${CompanyId}/get-site-by-company/`
        );
        setAllSites(response.data.results.data);
      } catch (error) {
        console.error("Error:", error);
        setapiLoading(false);
      } finally {
        setapiLoading(false);
      }
    };
    getReportData();
  }, []);

  useEffect(() => {
    const getReportData = async () => {
      setapiLoading(true);
      try {
        const response = await getRequest(
          `vendor/get-vendor-by-company/`
        );
        setAllVendors(response.data.results.data);
      } catch (error) {
        console.error("Error:", error);
        setapiLoading(false);
      } finally {
        setapiLoading(false);
      }
    };
    getReportData();
  }, []);

  useEffect(() => {
    const getReportData = async () => {
      setapiLoading(true);
      try {
        const response = await getRequest(
          `company-material-code/get-material/`
        );
        setAllMaterials(response.data.data);
      } catch (error) {
        console.error("Error:", error);
        setapiLoading(false);
      } finally {
        setapiLoading(false);
      }
    };
    getReportData();
  }, []);


  const getSourceData = async (record) => {
    try {
      setDetailsSource(record?.material_description);
    } catch (error) {
      console.error("Error fetching approval data:", error);
    }
  };
  const columns = [
    {
      title: "Category",
      dataIndex: "category_tree_name",
      key: "category_tree_name",
      // width: 120,
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      // width: 130,
    },
    {
      title: "PO Number",
      dataIndex: "po_number",
      key: "po_number",
      // width: 120
    },
    {
      title: "PO Date",
      dataIndex: "po_created_date",
      key: "po_created_date",
      // width: 120
    },
    {
      title: "Vendor Name",
      dataIndex: "vendor_name",
      key: "vendor_name",
      // width: 120
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      width: 120
    },
    {
      title: "Total Order Value (INR)",
      dataIndex: "total_order_value_with_gst",
      key: "total_order_value_with_gst",
      
      className: 'column-right',
      width: 180,
      render: (text, record) => {
        return (
          <div>
            ₹{" "}
            {record.total_order_value_with_gst?.toLocaleString("en-IN", {
              maximumFractionDigits: 0,
            })}
          </div>
        );
      },
    },
  ];
  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setEndDate(formattedDate);
  };

  const handlePdfDownload = async () => {
    // const worksheet = XLSX.utils.json_to_sheet(dataSource);
    // const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, 'Table Data');
    // XLSX.writeFile(workbook, `po_spend_analysis${+new Date()}.xlsx`);

    /* PDF Download */
    const pdf = new jsPDF("p", "pt", "a4");
    const pdfColumns = [
      "Category",
      "Company Name",
      "PO Number",
      "PO Date",
      "State",
      "Supplier Name",
    ];
    let rows = [];

    for (let i = 0; i < dataSource.length; i++) {
      let temp = [
        dataSource[i].category_tree_name,
        dataSource[i].company_name,
        dataSource[i].po_number,
        dataSource[i].po_created_date !== null
          ? dataSource[i].po_created_date
          : "",
        dataSource[i].state,
        dataSource[i].vendor_name,
      ];
      rows.push(temp);
    }
    pdf.text(200, 40, "PO Spend Analysis Report");
    pdf.autoTable(pdfColumns, rows, {
      startY: 65,
      theme: "grid",
      styles: {
        font: "times",
        halign: "center",
        overflow: "linebreak",
        cellPadding: 3.5,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
      },
      headStyles: {
        textColor: [255, 255, 255],
        fontStyle: "normal",
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        fillColor: [9, 78, 143],
      },
      alternateRowStyles: {
        fillColor: [212, 212, 212],
        textColor: [0, 0, 0],
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      rowStyles: {
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      tableLineColor: [0, 0, 0],
    });
    pdf.save(`po_spend_analysis${+new Date()}`);
  };
  const handleRefresh = async () => {
    setClickedFilterButton(false);
    setEndDate("");
    setStartDate("");

    formRef.current.setFieldsValue({
      po_created_date__gte: null,
      pr_created_date__lte: null,
      pr_created_date__gte: null,
      rfq_created_date__gte: null,
      rfq_detail: null,
      category_id: null,
      rfq_created_date__lte: null,
    });
    form.setFieldsValue({ search: "" });
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
    });
  };
  const handleReset = () => {
    setEndDate("");
    setStartDate("");
    setClickedFilterButton(false);
    setState({
      page: 1,
      pagesize: 10,
      site_id: "",
      vendor_id: "",
      material_id: ""
    });
    
    formRef.current.setFieldsValue({
      po_created_date_gte: null,
      po_created_date_lte: null,
    });
    setSelectedMaterial("");
    setSelectedSite("");
    setSelectedVendor("");
  };
  const handleClearFields = () => {
    setEndDate("");
    setStartDate("");
    setSelectedMaterial("");
    setSelectedSite("");
    setSelectedVendor("");
  };
  const handleApplyFilter = () => {
    setClickedFilterButton(true);
    const filterParams = {
      ...state,
      po_created_date_gte: startDate,
      po_created_date_lte: endDate,
      site_id: selectedSite,
      vendor_id: selectedVendor,
      material_id: selectedMaterial
    };

    setState(filterParams);
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    //const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
    });
  };

  const expandedRowRender = (record) => {
    const columns = [
      {
        title: "Item",
        dataIndex: "bid_material_type_name",
        key: "bid_material_type_name",
      },
      {
        title: "UoM.",
        dataIndex: "bid_uom",
        key: "bid_uom",
      },
      {
        title: "Quantity",
        dataIndex: "bid_material_quantity",
        key: "bid_material_quantity",
      },
      {
        title: "Unit Price (INR)",
        dataIndex: "unit_rate",
        key: "unit_rate",
        className: 'column-right',
        // width: 120,
        render: (text, record) => {
          return (
            <div>
              ₹{" "}
              {record.unit_rate?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              })}
            </div>
          );
        },
      },
    ];

    return (
      <Table
        scroll={{
          // y: 400,
          x: 1000,
        }}
        className="subtbl"
        columns={columns}
        dataSource={detailsSource}
        pagination={false}
        // loading={loading}
      />
    );
  };

  const handleExpand = async (expanded, record, index) => {
    if (expanded) {
      setDetailsSource([]);
      await getSourceData(record);
      setExpandedRowKeys([index]);
    } else {
      setExpandedRowKeys([]);
    }
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Visualize Item , State, City and Date wise specific
                  procurement data using charts and graphs for easier
                  interpretation and analysis.
                </span>
              }
            >
              <h3>Purchase Order Spend Analysis Report</h3>
            </Tooltip>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/purchase-requisition-history">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {" "}
                Purchase Order Spend Analysis Report
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

  
        <section className="grid-sec tablegridsec">
          <div className="PR-body">
          {
          authUserData().company_role === "Company Admin" && authUserData().employee === null && <SubscriptionNotification />
        }
            <div className="filterrow">
              <div className="filtercol">
                <Form autoComplete="off" ref={formRef}>
                  <Space wrap>
                    <Col xs={24} className="TextFeild gutter-row">
                      <Form.Item name="po_created_date_gte">
                        <DatePicker
                          format="DD-MM-YY"
                          allowClear={false}
                          placeholder="Select Start Date"
                          value={startDate}
                          // onChange={handleStartDateChange}
                          onChange={(value) => handleStartDateChange(value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} className="TextFeild gutter-row">
                      <Form.Item name="po_created_date_lte">
                        <DatePicker
                          format="DD-MM-YY"
                          allowClear={false}
                          placeholder="Select End Date"
                          value={endDate}
                          // onChange={handleEndDateChange}
                          onChange={(value) => handleEndDateChange(value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} className="TextFeild gutter-row">
                      <Form.Item name="site_name">
                        <Select
                          showArrow
                          showSearch
                          allowClear
                          placeholder="Select Site"
                          optionFilterProp="children"
                          onChange={(value) => setSelectedSite(value)}
                          style={{ width: "150px" }}
                        >
                          {allSites &&
                            allSites.length > 0 &&
                            allSites.map((item) => (
                              <Select.Option
                                key={item.id}
                                value={item.id}
                              >
                                {item.site_name}
                              </Select.Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} className="TextFeild gutter-row">
                      <Form.Item name="material_type_name">
                        <Select
                          showArrow
                          showSearch
                          allowClear
                          placeholder="Select Material"
                          optionFilterProp="children"
                          onChange={(value) => setSelectedMaterial(value)}
                          style={{ width: "150px" }}
                        >
                          {allMaterials &&
                            allMaterials.length > 0 &&
                            allMaterials.map((item) => (
                              <Select.Option
                                key={item.id}
                                value={item.id}
                              >
                                {item.material_type_name}
                              </Select.Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} className="TextFeild gutter-row">
                      <Form.Item name="vendor">
                        <Select
                          showArrow
                          showSearch
                          allowClear
                          placeholder="Select Vendor"
                          optionFilterProp="children"
                          onChange={(value) => setSelectedVendor(value)}
                          style={{ width: "150px" }}
                        >
                          {allVendors &&
                            allVendors.length > 0 &&
                            allVendors.map((item) => (
                              <Select.Option
                                key={item.id}
                                value={item.id}
                              >
                                {item.vendor_registered_name}
                              </Select.Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <>

<Button
  type="primary"
  icon={
    <Tooltip title="Apply" color="#094E8F">
      <FilterOutlined style={{ fontSize: "20px" }} />
    </Tooltip>
  }
  onClick={() => {
    const hasFilter = [
      startDate,
      endDate,
      selectedMaterial,
      selectedSite,
      selectedVendor,
    ].some(
      (val) =>
        val !== null &&
        val !== undefined &&
        val !== "" &&
        !(Array.isArray(val) && val.length === 0)
    );

    if (hasFilter) {
      handleApplyFilter();
    } else {
      message.warning("Please select at least one filter.");
    }
  }}
  style={{
    backgroundColor: "#094e8f",
    color: "#ffffff",
    border: "none",
    width: "40px",
    height: "40px",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
  }}
/>


                      <Button
                        htmlType="Reset"
                        type="primary"
                        icon={
                          <Tooltip title="Reset" color="#094E8F">
                            <UndoOutlined style={{ fontSize: "20px" }} />
                          </Tooltip>
                        }
                        onClick={
                          clickedFilterButton ? handleReset : handleClearFields
                        }
                        style={{
                          backgroundColor: "#094e8f",
                          color: "#ffffff",
                          border: "none",
                          width: "40px",
                          height: "40px",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          borderRadius: "4px",
                        }}
                      />
                    </>
                  </Space>
                </Form>
              </div>
              <div className="btnscol">
                <Space>

                  {/* <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="PDF"
                    label="PDF"
                    onClick={handlePdfDownload}
                    icon={<img src={ExelDownload} alt="Plus Square" />}
                  /> */}
                </Space>
              </div>
            </div>
          
              <div className="tablewrp">
                  {/* <Spin spinning={apiLoading}> */}
              <Table
                scroll={{
                  // y: 400,
                  x: 1000,
                }}
                columns={columns}
                dataSource={dataSource}
                rowKey={(record, index) => index}
                loading={apiLoading}
                pagination={{
                  defaultCurrent: state.page,
                  defaultPageSize: state.pagesize,
                  total: totalCount,
                  showSizeChanger: true,
                  locale: {
                    items_per_page: "Items / Page",
                  },
                  showTotal: (total) => `Total ${total} items`,
                }}
                onChange={handleTableChange}
                expandable={{
                  expandedRowRender: (record) => expandedRowRender(record),
                  onExpand: (expanded, record) => {
                    const index = dataSource.indexOf(record); // Calculate index based on the position of the record in the dataSource
                    handleExpand(expanded, record, index); // Pass index to handleExpand
                  },
                  expandedRowKeys,
                }}
              />
              {/* </Spin> */}
              </div>
           
          </div>
        </section>
    
    </>
  );
};

export default PurchaseOrderSpendAnalysisReport;
